import {environment} from '../../environments/environment';

export class HttpUtils {
    public static getUiMountPoint() {
        return environment.loadedInVCRemotePlugin ? (window.location.pathname.match(/(.*)(\/hcx)(\/.*|$)/) || [])[1] : '/hybridity/ui';
    }

    public static getBaseUrl(): string {
       if (ENV === 'production') {
           if(environment.loadedInVCRemotePlugin) {
                let path = (window.location.pathname.match(/(.*)(\/hcx)(\/.*|$)/) || [])[1];
                return path + '/hcx-ui/rest';
           }else {
                return '';
           }
       }
       return '';
    }
    public static getSiteUrl(): string {
        let url     = document.createElement('a');
        url.href    = window.location.href;
        let siteUrl = url.protocol + '//' + url.host;
        return siteUrl;
    }
    public static isNspDeactivated(url: string): boolean {
        let hcxLicenseData = JSON.parse(sessionStorage.getItem('hcx-license-data'));
        let nspDeactivated = (hcxLicenseData && hcxLicenseData.data && hcxLicenseData.data.activationStatus && hcxLicenseData.data.activationStatus == "deactivated") ? true : false;
        let excludedApi : string[] = [
            '/hybridity/api/session',
            '/hybridity/api/hcspAppliances?',
            '/hybridity/api/auditLogs/archive',
            '/hybridity/api/auditLogs?',
            '/hybridity/api/metainfo/context/publisher',
            '/hybridity/api/downloads',
            '/hybridity/api/upgrade?',
            'hybridity/api/featureConfig?',
            '/hybridity/api/techsupport?action=collectTechSupportBundle'

        ];
        let isExcludedApi: boolean = false;
        excludedApi.forEach(item => {
            if (url.indexOf(item) !== -1) {
                isExcludedApi = true;
                return;
            }
        });
        if (nspDeactivated && !isExcludedApi ) {
            return true;
        } else {
            return false;
        }        
    }
}



// WEBPACK FOOTER //
// ./src/common/http/http-utils.ts